import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import { DRAWER_TABS } from "../../../../../../utils/constants";

const ControlRemediateSection = ({ setTab }) => {
  const colors = useColors();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Typography typography={"subtitle1"}>How to Remediate?</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "4px",
          cursor: "pointer",
        }}
        onClick={() => {
          setTab(DRAWER_TABS.REMEDIATION_TAB);
        }}
      >
        <Typography
          typography={"subtitle2"}
          sx={{
            color: colors.primary_main,
          }}
        >
          Go to Remediation
        </Typography>
        <ArrowForwardIcon sx={{ width: "12px", color: colors.primary_main }} />
      </Box>
    </Box>
  );
};

export default ControlRemediateSection;
